import React from 'react';
import { CheckIcon, LockIcon, CreditCardIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { FadeIn } from './FadeIn';
export function ProductPresentation() {
  return <section className="py-8 md:py-20 px-4 bg-gradient-to-br from-white via-kid-purple/5 to-kid-pink/5 relative overflow-hidden" data-id="element-284">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-285">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-286">
          {/* Product Mockup */}
          <FadeIn direction="right" data-id="element-287">
            <div className="relative w-full max-w-lg mx-auto" data-id="element-288">
              <img src="https://cdn.magicpatterns.com/uploads/amss8XA8X9Qmarc4J38DBE/20260307_1715_Image_Generation_simple_compose_01kk4yzbgweby8nda2gf500bht_(1).webp" alt="Sistema de Lectura en Orden Correcto - Paquete Completo" className="w-full h-auto rounded-2xl shadow-sm" data-id="element-289" />
            </div>
          </FadeIn>

          {/* Pricing & Offer */}
          <FadeIn direction="left" data-id="element-290">
            <div className="flex flex-col" data-id="element-291">
              <div className="inline-block bg-kid-purple/10 text-kid-purple font-semibold text-xs tracking-wider uppercase px-3 py-1 rounded-md mb-3 md:mb-4 w-max border border-kid-purple/20" data-id="element-292">
                Presentamos
              </div>

              <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6 leading-tight" data-id="element-293">
                Todo el sistema listo para aplicar desde hoy
              </h2>

              <div className="text-base md:text-lg text-gray-600 font-normal mb-5 md:mb-8 leading-relaxed" data-id="element-294">
                <p data-id="element-295">
                  Al acceder recibís un método completo organizado paso a paso
                  para que puedas acompañar el aprendizaje de tu hijo con
                  claridad y sin improvisar.
                </p>
              </div>

              <ul className="space-y-2.5 md:space-y-3 mb-6 md:mb-10" data-id="element-296">
                {[{
                text: 'Sistema completo paso a paso',
                color: 'text-kid-purple'
              }, {
                text: 'Más de 200 actividades imprimibles',
                color: 'text-kid-pink'
              }, {
                text: 'Material organizado por niveles',
                color: 'text-kid-sky'
              }, {
                text: 'Guía clara para padres',
                color: 'text-kid-lime'
              }].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-gray-700 font-medium text-sm md:text-base p-2.5 md:p-3 rounded-xl bg-white border border-gray-100 shadow-sm" data-id="element-297">
                    <CheckIcon className={`w-5 h-5 ${item.color} flex-shrink-0`} data-id="element-298" />
                    <span data-id="element-299">{item.text}</span>
                  </li>)}
              </ul>

              <div className="bg-gradient-to-br from-kid-purple/5 via-kid-pink/5 to-kid-sky/5 p-6 md:p-8 rounded-2xl border border-white shadow-sm relative overflow-hidden" data-id="element-300">
                <div className="text-center" data-id="element-301">
                  <p className="text-sm md:text-base font-semibold text-gray-700 mb-3" data-id="element-302">
                    Hoy podés acceder al sistema completo
                  </p>

                  <div className="mb-2" data-id="element-303">
                    <span className="text-gray-500 font-medium text-sm" data-id="element-304">
                      Valor real del sistema:{' '}
                    </span>
                    <span className="text-gray-400 font-medium text-sm line-through decoration-1" data-id="element-305">
                      $89.999 ARS
                    </span>
                  </div>

                  <div className="mb-4 md:mb-6" data-id="element-306">
                    <span className="flex items-center justify-center text-gray-500 font-semibold text-xs mb-1 tracking-wider uppercase" data-id="element-307">
                      HOY
                      <span className="animate-pulse bg-kid-rose rounded-full w-2 h-2 inline-block ml-2" data-id="element-308"></span>
                    </span>
                    <span className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-kid-purple to-kid-pink bg-clip-text text-transparent" data-id="element-309">
                      $19.999 ARS
                    </span>
                  </div>

                  <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-gray-500 font-medium mb-5 md:mb-8" data-id="element-310">
                    <span data-id="element-311">Pago único</span>
                    <span className="text-gray-300" data-id="element-312">·</span>
                    <span data-id="element-313">Sin suscripciones</span>
                    <span className="text-gray-300" data-id="element-314">·</span>
                    <span data-id="element-315">Acceso inmediato</span>
                  </div>

                  <CTAButton text="QUIERO EL SISTEMA AHORA »" size="xl" className="w-full mb-3 md:mb-4" animatePulse={true} data-id="element-316" />

                  <p className="text-xs md:text-sm text-kid-lime font-medium mb-4 md:mb-6 bg-kid-lime/10 py-1.5 px-3 rounded-md inline-block border border-kid-lime/20" data-id="element-317">
                    Descarga inmediata del paquete completo
                  </p>

                  {/* Trust Elements */}
                  <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 pt-4 md:pt-6 border-t border-gray-200" data-id="element-318">
                    <div className="flex items-center gap-1.5 text-gray-500" data-id="element-319">
                      <LockIcon className="w-4 h-4 text-kid-purple" data-id="element-320" />
                      <span className="text-[10px] font-semibold tracking-wider" data-id="element-321">
                        PAGO SEGURO
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 text-gray-500" data-id="element-322">
                      <ShieldCheckIcon className="w-4 h-4 text-kid-pink" data-id="element-323" />
                      <span className="text-[10px] font-semibold tracking-wider" data-id="element-324">
                        GARANTÍA
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 text-gray-500" data-id="element-325">
                      <CreditCardIcon className="w-4 h-4 text-kid-sky" data-id="element-326" />
                      <span className="text-[10px] font-semibold tracking-wider" data-id="element-327">
                        TARJETAS
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}